import { queryClient } from "@app/config/api/api";
import { userDetailsOptions } from "@app/queries/iam";
import { updateUser } from "@app/state/actions";

export async function getUserDetails() {
  const user = await queryClient.fetchQuery(userDetailsOptions);
  updateUser(user);
  return user;
}
